// ----------------------------------------------------------------------------
// Snippet: Search
// ----------------------------------------------------------------------------
// Search bar, on header and on the Search Results template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_search-form.scss';

// Variables
const SEARCH_FORM = '.search-box';
const SEARCH_ICON = '.search-box__toggle';
const SEARCH_INPUT = '.search__input';
const SEARCH_CLOSE = '.search__close';
const PREDICTIVE_SEARCH = '#predictive-search';
const FORM_LABEL = '.form__label';
const SEARCH_OVERLAY = '#search-overlay';

// Functions
function openSearchForm(searchForm) {

    if (searchForm != null) {
        searchForm.classList.add('is-active');

        const searchInput = searchForm.querySelector(SEARCH_INPUT);

        if (searchInput != null) {
            searchInput.focus();
        }

        const currentScrollX = window.scrollX;
        const currentScrollY = window.scrollY;
        window.scrollTo(currentScrollX, currentScrollY);
    }
}

function closeSearchForm(searchForm) {

    if (searchForm != null) {
        searchForm.classList.remove('is-active');
        const predictiveSearch = searchForm.querySelector(PREDICTIVE_SEARCH);
        const searchInput = searchForm.querySelector(SEARCH_INPUT);
        const searchOverlay = document.querySelector(SEARCH_OVERLAY);


        if (searchInput != null) {
            searchInput.value = '';
        }
    }
}

// If you click anywhere outside of the search, close it
// document.body.addEventListener('click', function(event){

//     if (event.target.closest(SEARCH_FORM) == null && document.querySelector(SEARCH_FORM)!= null) {
//         const searchForms = document.querySelectorAll(SEARCH_FORM);

//         searchForms.forEach((searchForm) => {
//             closeSearchForm(searchForm);
//         });
//     }
// });

document.addEventListener('DOMContentLoaded', function() {

    // When you click the close button, remove open class and clean input
    const searchCloseIcons = document.querySelectorAll(SEARCH_CLOSE);
    searchCloseIcons.forEach((searchClose) => {

        searchClose.addEventListener('click', function(event) {

            const searchForm = event.target.closest(SEARCH_FORM);
            closeSearchForm(searchForm);

        });
    });

    // When you click the search icon, toggle the open state
    const searchIcons = document.querySelectorAll(SEARCH_ICON);
    searchIcons.forEach((searchIcon) => {

        searchIcon.addEventListener('click', function(event) {
            event.preventDefault();

            const searchForm = event.target.closest(SEARCH_FORM);
            searchForm.classList.contains('is-active') ? closeSearchForm(searchForm) : openSearchForm(searchForm);
        });
    });

    // When the search input is in focus state and you click Escape, close the searchbox
    const searchInputs = document.querySelectorAll(SEARCH_INPUT);

    searchInputs.forEach((searchInput) => {

        searchInput.addEventListener('keyup', function(e) {

            if (e.key == 'Escape') {
                const searchForm = e.target.closest(SEARCH_FORM);
                closeSearchForm(searchForm);
            }
        });
    });

    // Allows label on mobile to also target the search
    const searchForms = document.querySelectorAll(SEARCH_FORM);

    searchForms.forEach((searchForm) => {

        const formLabel = searchForm.querySelector(FORM_LABEL);
        formLabel.addEventListener('click', function(event) {
            const searchForm = event.target.closest(SEARCH_FORM);
            searchForm.classList.contains('is-active') ? closeSearchForm(searchForm) : openSearchForm(searchForm);
        });
    });

    // Close search box when clicking outside of it
    document.addEventListener('click', function(event) {
        const clickedElement = event.target;

        // Check if the clicked element is outside all search boxes
        const isOutsideSearchBox = !clickedElement.closest(SEARCH_FORM);

        if (isOutsideSearchBox) {
            // Close all active search boxes
            const activeSearchForms = document.querySelectorAll(SEARCH_FORM + '.is-active');
            activeSearchForms.forEach((searchForm) => {
                closeSearchForm(searchForm);
            });
        }
    });
});
